/**
 * @file viewPath.js
 * @description The URL for an app view. The home view lives at "/", never "/home": the app used to rewrite "/" to
 *   "/home" in the browser, which Bing treats as a redirect ("The inspected URL is a redirect"), so the canonical
 *   homepage could not be indexed (2026-10-21). Every place that puts a view in the address bar uses this.
 * @module lib/viewPath
 */

/** "/" for the home view (and "/es" for the Spanish home), "/<view>" for everything else. */
export function pathForView(view, { spanishHome = false } = {}) {
  if (view === "home") return spanishHome ? "/es" : "/";
  return "/" + view;
}
